import React from "react";
import styles from "../component/custom.module.css";
import Images from "./Images";

const DateSection = ({ executeScroll }) => {
  return (
    <section className={styles.DateSection}>
      <div className="container-fluid">
        <div className={styles.DateSectionMain}>
          <div className={`${styles.DateSectionInnerNew}`}>
            <h2>Important Dates</h2>
          </div>
          <div className={styles.DateSectionInner}>
            <div className={styles.DateSectionInnerInfo}>
              <div className={styles.DateSectionInfoDate}>
                <p>28</p>
                <span>Sept</span>
              </div>
              <a href="#">Registrations open</a>
            </div>
            <div className={styles.DateSectionInnerInfo}>
              <div className={styles.DateSectionInfoDate}>
                <p>10</p>
                <span>Nov</span>
              </div>
              <a href="#">Registrations close</a>
            </div>
          </div>
          <div className={styles.DateSectionMid}>
            <h2>Important Dates</h2>
          </div>
          <div className={`${styles.DateSectionInner}`}>
            <div className={styles.DateSectionInnerInfo}>
              <div className={styles.DateSectionInfoDate}>
                <p>16</p>
                <span>Nov</span>
              </div>
              <a href="#">
                Top 10 Entries <br /> Announcement{" "}
              </a>
            </div>
            <div className={styles.DateSectionInnerInfo}>
              <div className={styles.DateSectionInfoDate}>
                <p>29</p>
                <span>Nov</span>
              </div>
              <a href="#">
                Contest Winner <br /> Announcement{" "}
              </a>
            </div>
          </div>
        </div>
        {/* <div className={styles.scrollDown} onClick={executeScroll} style={{cursor:"pointer"}}>
                <p>Scroll</p>
                <img src={Images.ScrollDown} />    
            </div> */}
      </div>
    </section>
  );
};

export default DateSection;
